import { pipe, string, nonEmpty, minLength, email as eml, literal, union, optional, boolean, regex } from 'valibot' // eslint-disable-line

export const name = pipe(
  string('Your name is required'),
  nonEmpty('Please enter your name.'),
  minLength(2, 'Name must be at least 2 characters')
)

export const surname = pipe(
  string('Your surname is required'),
  nonEmpty('Please enter your surname.'),
  minLength(2, 'Surname must be at least 2 characters')
)

export const email = pipe(
  // union([
  //   literal(''), // Allow empty string
  //   string('Your email is required')
  // ]),
  optional(string(), ''),
  // string('Your email is required'),
  // nonEmpty('Please enter your email.'),
  eml('Invalid email format')
)

export const phoneNumber = pipe(
  string('Your phone is required'),
  nonEmpty('Please enter your phone.'),
  minLength(2, 'Phone must be at least 2 characters')
)

export const role = pipe()

export const password = pipe(
  string('Password is required'),
  nonEmpty('Please enter your password.'),
  minLength(8, 'Password must be at least 8 characters')
)

export const passwordConfirmation = pipe(
  string('Password confirmation is required'),
  nonEmpty('Please confirm your password.'),
  minLength(8, 'Password must be at least 8 characters')
)

export const remember = pipe()

export const totpCode = pipe(
  string('Verification code is required'),
  nonEmpty('Please enter your verification code.'),
  regex(/^\d{6}$/, 'Enter the 6-digit code from your authenticator app')
)
